import { init } from "@rematch/core";
import selectPlugin from "@rematch/select";
import createLoadingPlugin from "@rematch/loading";
import logger from "redux-logger";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
import persistPlugin from "@rematch/persist";
import storage from "redux-persist/lib/storage";

import * as models from "@/models";

export const history = createBrowserHistory();
const { routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const persistConfig = {
  key: "submit",
  storage,
  whitelist: ["user"],
};

const store = init({
  redux: {
    reducers: { router: routerReducer },
    middlewares: [routerMiddleware, logger],
    devtoolOptions: {},
  },
  models,
  plugins: [
    selectPlugin(),
    createLoadingPlugin(),
    persistPlugin(persistConfig),
  ],
});

export default store;
